import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Gift } from 'lucide-react';
import { apiService } from '../services/apiService';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [hasVoucherBonus, setHasVoucherBonus] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      apiService.checkSessionVoucher(sessionId)
        .then(res => setHasVoucherBonus(res.hasVoucherBonus))
        .catch(() => {});
    }
  }, [searchParams]);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/plans');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ maxWidth: 440, margin: '48px auto 0' }}>
      <div className="pk-card" style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', display: 'grid', placeItems: 'center', background: 'var(--arc-success-soft)', color: 'var(--arc-success)' }}>
            <CheckCircle size={26} />
          </div>
        </div>

        <h1 className="pk-h2" style={{ marginBottom: 10 }}>Subscription Activated!</h1>

        <p className="pk-body" style={{ marginBottom: 20 }}>
          Your subscription has been successfully activated. You now have access to your monthly quota and discounted rates.
        </p>

        {hasVoucherBonus && (
          <div className="pk-note pk-note-accent" style={{ marginBottom: 16, textAlign: 'left' }}>
            <Gift size={16} style={{ flexShrink: 0, marginTop: 1 }} />
            <div>
              <p style={{ fontWeight: 700, color: 'var(--arc-ink)', margin: 0 }}>Thank you for subscribing with a voucher!</p>
              <p className="pk-small" style={{ marginTop: 4 }}>
                As a token of gratitude, we've added <strong>$5 in free credits</strong> to your account. These can be used towards AI response costs.
              </p>
            </div>
          </div>
        )}

        <div className="pk-note pk-note-accent" style={{ marginBottom: 20, textAlign: 'left' }}>
          <p className="pk-small">Your quota will be available immediately. You'll be redirected to your dashboard in a few seconds.</p>
        </div>

        <button type="button" onClick={() => navigate('/plans')} className="pk-btn pk-btn-ink pk-btn-block">
          View Plans & Billing
        </button>
      </div>
    </div>
  );
}
